/* CAMPAIGN OFFER TYPES DATA */
export const GET_CAMPAIGN_OFFER_TYPES_LIST = "GET_CAMPAIGN_OFFER_TYPES_LIST"
export const SET_CAMPAIGN_OFFER_TYPES_LIST = "SET_CAMPAIGN_OFFER_TYPES_LIST"

/* CAMPAIGNS OFFER ACTIONS */
export const ADD_CAMPAIGN_OFFER_TYPES = "ADD_CAMPAIGN_OFFER_TYPES"
export const DELETE_CAMPAIGN_OFFER_TYPES = "DELETE_CAMPAIGN_OFFER_TYPES"

/* CAMPAIGN OFFER TYPE PROFILE DATA */
export const GET_CAMPAIGN_OFFER_TYPE_PROFILE = "GET_CAMPAIGN_OFFER_TYPE_PROFILE"
export const SET_CAMPAIGN_OFFER_TYPE_PROFILE = "SET_CAMPAIGN_OFFER_TYPE_PROFILE"
export const UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE = "UPDATE_CAMPAIGN_OFFER_TYPE_PROFILE"
export const SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE = "SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_OFFER_TYPES_LOADER = "SHOW_CAMPAIGN_OFFER_TYPES_LOADER"
export const HIDE_CAMPAIGN_OFFER_TYPES_LOADER = "HIDE_CAMPAIGN_OFFER_TYPES_LOADER"
